export function hexToRgb(hex) {
  const shorthandRegex = /^#?([\da-f])([\da-f])([\da-f])$/i;
  const expandedHex = hex.replace(shorthandRegex, (input, red, green, blue) => red + red + green + green + blue + blue);
  const result = /^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i.exec(expandedHex);
  return result ? `${Number.parseInt(result[1], 16)}, ${Number.parseInt(result[2], 16)}, ${Number.parseInt(result[3], 16)}` : '';
}